import React from "react"
import LoadingSpinner from "../../components/global/LoadingSpinner/LoadingSpinner"

const Loading = () => (
  <div className="flex justify-center items-center w-full h-screen">
    <LoadingSpinner/>
  </div>
)

export default Loading